import { get } from 'lodash';
import {
	GO_BACK_PAGE,
	UPDATE_VERIFICATION_STATUS_FAILURE,
	GO_TO_ACCOUNTS,
	FETCH_MY_PAYMENTS_TO_AUTHORISE_REQUEST,
	FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_REQUEST,
	FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_REQUEST,
	UPDATE_VERIFICATION_STATUS_REQUEST,
	FETCH_MY_PAYMENTS_TO_AUTHORISE_FAILURE,
	FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_FAILURE,
	FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_FAILURE,
	UPDATE_VERIFICATION_SUBMISSION_DATE_FAILURE,
	UPDATE_VERIFICATION_STATUS_SUCCESS,
	CLOSE_ALERT,
	GET_ALL_MISSING_DETAILS_FAILURE,
} from './actions';
import { SELECT_TO_AUTHORISE, SELECT_TO_VIEW, SELECT_TO_EDIT } from '../payments/actions';
import { GET_ALL_BENEFICIARIES_REQUEST, GET_ALL_BENEFICIARIES_FAILURE } from '../payees/actions';
import { SUBMIT_GET_EXCHANGE_RATES_REQUEST } from '../rates/actions';
import { REVIEWED } from '../../constants/Constants';
import { GET_ACCOUNTS_BY_CAPABILITY_FAILURE } from '../accounts/actions';

const initialPage = {
	name: 'PaymentAuthListings',
	fileUploadReviewed: false,
};

const requestActions = [
	FETCH_MY_PAYMENTS_TO_AUTHORISE_REQUEST,
	FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_REQUEST,
	FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_REQUEST,
	UPDATE_VERIFICATION_STATUS_REQUEST,
	GET_ALL_BENEFICIARIES_REQUEST,
	SUBMIT_GET_EXCHANGE_RATES_REQUEST,
];

const requestFailures = [
	FETCH_MY_PAYMENTS_TO_AUTHORISE_FAILURE,
	FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_FAILURE,
	FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_FAILURE,
	UPDATE_VERIFICATION_STATUS_FAILURE,
	UPDATE_VERIFICATION_SUBMISSION_DATE_FAILURE,
	GET_ALL_BENEFICIARIES_FAILURE,
	GET_ACCOUNTS_BY_CAPABILITY_FAILURE,
	GET_ALL_MISSING_DETAILS_FAILURE,
];

const page = (state = initialPage, action) => {
	if (requestActions.includes(action.type) && get(action, 'error', false)) {
		return { ...state, hasError: true };
	}

	if (requestFailures.includes(action.type)) {
		if (action.type === UPDATE_VERIFICATION_STATUS_FAILURE && action.meta.status === REVIEWED) {
			return {
				...state,
				hasFileUploadError: true,
				fileUploadStatus: action.payload.status,
				fileUploadSettlementDate: action.payload.response.new_settlement_date,
				fileUploadSubmissionDate: action.payload.response.new_submission_date,
				fileUploadErrorMessage: action.payload.message,
			};
		}
		return { ...state, hasError: true };
	}

	if (action.type === UPDATE_VERIFICATION_STATUS_SUCCESS && action.meta.status === REVIEWED) {
		return { ...state, fileUploadReviewed: true };
	}

	if (action.type === CLOSE_ALERT) {
		return {
			...state,
			fileUploadReviewed: false,
			hasFileUploadError: false,
		};
	}

	switch (action.type) {
		case GO_BACK_PAGE: {
			const currentPage = state.name;
			switch (currentPage) {
				case 'PaymentAuthListings':
					return state;
				case 'View':
				case 'Authorise':
					return {
						...state,
						name: 'PaymentAuthListings',
					};
				default:
					return state;
			}
		}
		case SELECT_TO_AUTHORISE: {
			return { fileUploadReviewed: false, name: 'Authorise' };
		}
		case SELECT_TO_VIEW: {
			return { fileUploadReviewed: false, name: 'View' };
		}
		case GO_TO_ACCOUNTS:
			return {
				fileUploadReviewed: false,
				name: 'Accounts',
			};

		case SELECT_TO_EDIT: {
			return { fileUploadReviewed: false, name: 'Edit' };
		}

		default:
			return state;
	}
};

export default page;
